import { Action, Module, VuexModule } from "vuex-module-decorators";
import { WorkingTimes } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";

@Module
export default class WorkingTimeModule extends VuexModule {
    @Action
    [WorkingTimes.findPageWorkingTime]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/workingtime/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [WorkingTimes.saveWorkingTime](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/workingtime/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}